import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC4EMbRAYQuKrhdwpQfX-wuNwNlJsec7EE",
  authDomain: "offcourtza.firebaseapp.com",
  projectId: "offcourtza",
  storageBucket: "offcourtza.firebasestorage.app",
  messagingSenderId: "409184657476",
  appId: "1:409184657476:web:ff2cf199f46d047623dc11",
  measurementId: "G-Q3XK16M5LM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app;